import { render } from "./StoresSlick.vue?vue&type=template&id=04c0156f"
import script from "./StoresSlick.vue?vue&type=script&lang=js"
export * from "./StoresSlick.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/apps/StoresSlick.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "04c0156f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04c0156f', __exports__)) {
    api.reload('04c0156f', __exports__)
  }
  
  module.hot.accept("./StoresSlick.vue?vue&type=template&id=04c0156f", () => {
    api.rerender('04c0156f', render)
  })

}


export default __exports__